module.exports = __webpack_public_path__ + "static/media/s_v8_t6.fdedbfbe.mp3";